export default {
    systemDb: {
        title: 'System Dashboard',
        commandsTitle: 'Commands Sent',
        pingCommandsTitle: 'Pings Sent',
        cmdPriorityTitle: 'Command Priorities',
        throughputTitle: 'Throughput',
        CommandSuccess: 'Success Rate',
        CommandCounts: 'Command Counts',
        commandsSent: 'Commands Sent',
        commandsCompleted: 'Commands Completed',
        successRate: 'Success Rate %',
        rcdcSuccess: 'Electric Remote Connect/Disconnect Success',
        rcdcSuccessGraphLabel: 'Percentage',
        rcdcOverTime: 'Electric Remote Connect/Disconnect Time',
        rcdcOverTimeGraphLabel: 'Average Seconds',
        CommandAverageTime: 'Without a Buddy',
        CommandAverageTimeUsedBuddy: 'Using a Buddy',
        throughput: 'Throughput',
        throughputGraphLabel: 'Percentage',
        appCodesTitle: 'App Messages',
        uplinkCountsTitle: 'Uplink Messages',
        uplinkCounts: 'Uplink Messages',
        uplinkCountsGraphLabel: 'Count',
        uplinkAirTime: 'Uplink Air Time',
        uplinkAirTimeGraphLabel: 'Seconds',
        frequencyCounts: 'Frequency Counts',
        errorRetrievingFrequencyCounts : 'Error Retrieving Frequency Count Data',
        frequency: 'Frequency',
        snrTooltip: 'The daily averages of the best direct route for each radio',
        RIS: 'Read Performance',
        Throughput: 'Throughput',
        SystemSNR: 'Endpoint SNR',
        snr: 'Endpoint SNR',
        snrGraphLabel: 'dB',
        city: 'City',
        cityRisThroughput: 'Read Performance and Throughput by City',
        cityRisThroughputGraphLabel: 'Percentage',
        deviceSetRisThroughput: 'Read Performance and Throughput by Set',
        lifeCycleRis: "Read Performance by Life Cycle State",
        lifecycle: "Life Cycle State",
        lifeCycleRisGraphLabel: "Percentage",
        set: 'Set',
        deviceSetRisThroughputGraphLabel: 'Percentage',
        lowestCityThroughput: 'Lowest City Throughput',
        lowestCityThroughputGraphLabel: 'Percentage',
        towerCount: 'Base Station Count',
        radioCount: 'Radio Count',
        radioCounts: {
            supervisory: 'Supervisory Count',
            priority: 'Priority Count',
            candi: 'C&I Count',
            receive: 'Receive Count',
            receiveb: 'Receive B Count',
            boost: 'Boost Count'
        },
        readIntervalSuccess: "Read Performance",
        readIntervalSuccessGraphLabel: "Percentage",
        UtilityRIS: "Utility Read Performance",
        SystemRIS: "System Read Performance",
        NonZeroRIS: "Minimum Read Performance",
        networkPerformance: 'Network Performance',
        readIntervalCollection: 'Read Interval Collection',
        billingReadCollection: 'Billing Read Collection',
        networkHealth: 'Network Health Overview',
        towerRNIComms: "Base Station/RNI Communication",
        offlineTowers: "Offline Base Stations/Collectors",
        unheardTowers: "Unheard Base Stations/Collectors",
        networkPulse: {
            issueCount: 'Currently {count} issues',
            noIssues: 'No issues'
        },
        builtinGroups: {
            networkPulse: 'Network Pulse',
            systemDefault: 'System Default',
            customDashboard: 'Custom Dashboard',
        }
    }
}
